import { FAQItem } from 'shared/api/FaqModel.ts'
import { Response } from 'shared/models/general.ts'

import { clientApi } from './clientApi'

export const FAQApi = {
  getFaq(params?: { is_popular?: boolean }) {
    return clientApi.get<Response<FAQItem[]>>(`/faq`, {
      params,
    })
  },
}
